import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/CarePlan/diagnoses-with-standard`;

export const getDiagnosesWithStandard = async () => {
  try {
    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching diagnoses with standard:", error);
    throw error;
  }
};